module.exports = __webpack_public_path__ + "img/google_play.519f26c5.svg";